import { useEffect, useState } from "react";
import { AuthTokenRetrieve, LoginButton } from "../Utility/AuthTokenRetrieve";
import { apiFetch } from "../Utility/api";
const AddLift = () =>{
    const [inputs, setInputs] = useState({});
    const [shouldShow, setShouldShow] = useState(false);
    const [saveMessage, setSaveMessage] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    let { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();

    useEffect(() => {
        setShouldShow(shouldShowGoogle);
    }, [shouldShowGoogle]);

    const saveLift = () => {
        if (!inputs.Name || !inputs.Type || inputs.Type === "-") {
            setSaveMessage("Please enter a workout name and type.");
            return;
        }

        setIsSaving(true);
        setSaveMessage("");
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                method: "Add Lift",
                Name: inputs.Name, 
                Type: inputs.Type
            }),
        };
        apiFetch("/workout/server/", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data && data.resp === "success") {
                    setInputs({});
                    setSaveMessage("Lift saved.");
                } else {
                    setSaveMessage("Unable to save lift.");
                }
            })
            .catch(() => {
                setSaveMessage("Unable to save lift.");
            })
            .finally(() => {
                setIsSaving(false);
            });
    }
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values) => ({ ...values, [name]: value }));
    };
    return (
        <div className="AddLift">
            {shouldShow ? (
                <>
                    <div className="inputDiv">
                        <label>Workout Name</label>
                        <input type="text"
                            name="Name"
                            className="inputBox"
                            style={{ backgroundColor: '#ebe1e8' }}
                            value={inputs.Name || ""}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="inputDiv">
                        <label>Type</label>
                        <select
                            type="Select"
                            name="Type"
                            className="inputBox"
                            value={inputs.Type || ""}
                            onChange={handleChange}
                            >
                        <option>-</option>
                        <option>Push 1</option>
                        <option>Pull 1</option>
                        <option>Legs 1</option>
                    </select>
                    </div>
                    <div>
                        <button
                            style={{margin: 'auto auto auto 10px'}}
                            className="summaryButton actionButton"
                            onClick={saveLift}
                            disabled={isSaving}
                        >
                            {isSaving ? "Saving..." : "Save"}
                        </button>
                    </div>
                    {saveMessage ? <p className="workoutStatusMessage">{saveMessage}</p> : null}
                </>
            ) : (
                <LoginButton setShouldShow={setShouldShow}></LoginButton>
            )}
        </div>
    )
}

export default AddLift;
